$(document).ready(function () {

    // Store Finder
    $(document).on('click', '.scasl-schedule-title', function (e) {
        $(this).siblings('.title').removeClass('active').next().slideUp();
        $(this).toggleClass('active');
        $(this).next('.scasl-schedule').slideToggle();
    });
    // Search Header Update
    $(document).on('click', '.icon_search,.site-header__search-toggle', function (e) {
        $('.site-header__mobile-nav').addClass('active_search');
        $('.search-bar').show();
    });

    $(document).on('click', '.search-bar__close', function (e) {
        $('.site-header__mobile-nav').removeClass('active_search');
        $('.search-bar,.algolia-autocomplete').hide();
    });

    $(document).on('click', function(e) {
        var container = $('.icon_search,.search-form__container,.site-header__search-toggle, .klevu-fluid');
        var container2 = $('.algolia-autocomplete');
        if (!container.is(e.target) && container.has(e.target).length === 0 && !container2.is(e.target) && container2.has(e.target).length === 0) {
            $('.site-header__mobile-nav').removeClass('active_search');
            $('.search-bar,.algolia-autocomplete').hide();
            if ($('body').hasClass('overlay')) {
                $('body').removeClass('overlay')
            }
        }
    });

    //discount cart
    $('.template-cart .discount .content').click(function(){
        $(this).next().toggle();
    })
    // Quantity cart
    $('.template-cart .product-form-item .product-form__input--quantity').each(function(){
        var qty = parseInt($(this).val());
        if (qty == 1) {
            $(this).closest('.product-form-item').find('.product-minus').first().addClass('disabled');
        }
    });

    $( document ).ajaxComplete(function() {
        $('.template-cart .product-form-item .product-form__input--quantity').each(function(index, input){
            var qty = parseInt($(input).val());
            if (qty == 1) {
                $(input).closest('.product-form-item').find('.product-minus').first().addClass('disabled');
                $(input).closest('.product-form-item').find('.product-minus').first().prop('disabled', true);
            }
        });
    });

    $(document).on('click', '.template-cart .product-form-item .product-minus', function() {
        var $inputQty = $(this).closest('.product-form-item').find('.product-form__input--quantity').first();
        var qty = parseInt($inputQty.val());
        $(this).prop('disabled', true);
        $(this).addClass('disabled');
        if(qty > 1){
            qty = qty - 1;
            $inputQty.val(qty).trigger('change');
        }
    });

    $(document).on('click', '.template-cart .product-form-item .product-plus', function() {
        var $inputQty = $(this).closest('.product-form-item').find('.product-form__input--quantity').first();
        var qty = parseInt($inputQty.val());
        $(this).prop('disabled', true);
        $(this).addClass('disabled');
        qty = qty + 1;
        $inputQty.val(qty).trigger('change');
    });

    // Product description Mobile
    var wScreen = $( window ).width();
    if( wScreen <= 992){
        $("#product-description").appendTo($("#product-description-mb"));
    }

    // Show Product-description in desktop-mobile
    if(wScreen > 767){
        $('.accordian-tab.description_tab').addClass('collapsed');
        $('.accordian-tab.description_tab .tab-content').hide();
    }

    // Product description
    $('#product-description .tab-title').on('click', function(){
        if( wScreen <= 480){
            $(this).parents(".accordian-tab").toggleClass("collapsed");
        }
        if($(this).parents('.accordian-tab').hasClass('open')){
            $(this).parents('.accordian-tab').find('.tab-content').slideUp();
            $(this).parents('.accordian-tab').removeClass('open');
        }
        else{
            $('.tab-content').slideUp();
            $('.accordian-tab').removeClass('open');
            $(this).parents('.accordian-tab').find('.tab-content').slideDown();
            $(this).parents('.accordian-tab').addClass('open');
        }
    });

    if( wScreen <= 480){
        $(".accordian-tab > .read-more__expand .btn").on("click", function () {
            $(this).parents(".accordian-tab").toggleClass("collapsed");
            $(this).text($(this).text() == "Continue Reading" ? "See Less" : "Continue Reading");
        });
        var content_height = $('.description_tab .tab-content').height();
        if(content_height < 250){
            $('.description_tab .read-more__expand').hide();
        }else{
            $('.description_tab').addClass("collapsed");
        }
    }

    // Recommended Products
    if($('.product-recomment').length > 0){
        setTimeout(function(){
            $('.product-recomment').owlCarousel({
                loop: false,
                margin: 16,
                nav: true,
                navText: ['<span class="nav-arrow-left"><i class="far fa-chevron-left"></i></span>','<span class="nav-arrow-right"><i class="far fa-chevron-right"></i></span>'],
                dots: false,
                lazyLoad: true,
                responsive:{
                    0:{
                        items:2,
                        margin: 17,
                        nav: false
                    },
                    600:{
                        items:3
                    },
                    1000:{
                        items:5
                    }
                }
            });
        },1500);
    };

    $('.gallary-images').slick({
        dots: false,
        infinite: false,
        slidesToShow: 4,
        slidePerRow: 4,
        vertical: true,
        slidesToScroll: 4,
        prevArrow: '<div class="arrow-prev"><i class="fas fa-chevron-up"></i></div>',
        nextArrow: '<div class="arrow-next"><i class="fas fa-chevron-down"></i></div>',
        responsive: [
            {
                breakpoint: 457,
                settings: {
                    vertical: false,
                    variableWidth: true,
                    prevArrow: '<div class="arrow-prev"><i class="fas fa-chevron-left"></i></div>',
                    nextArrow: '<div class="arrow-next"><i class="fas fa-chevron-right"></i></div>',
                }
            }
        ]
    });

    // Set height images wislist
    setTimeout(function(){
        $('.swym-item').each(function () {
            $('.swym-item .swym-outer .swym-inner .swym-image img').css('min-height', $('.swym-image img').height());
            $('.swym-item .swym-outer .swym-inner .swym-information .swym-price').css('min-height', $('.swym-item .swym-outer .swym-inner .swym-information .swym-price').height());
        });
    },4000);

    function handleError(XMLHttpRequest) {
        console.error("An error occurred: ", XMLHttpRequest);
    }

    // Open minicart
    $('.mini-cart-items .site-header__cart:not(.disabled)').on('click', function(e){
        if($(this).closest('.mini-cart-items').hasClass('active')){
            $('body').removeClass('open-minicart');
            $(this).closest('.mini-cart-items').removeClass('active');
        }else{
            $('body').addClass('open-minicart');
            $(this).closest('.mini-cart-items').toggleClass('active');
        }
    });

    $(document).on('click', '.close-minicart', function(e){
        $('body').removeClass('open-minicart');
        $(this).closest('.mini-cart-items').removeClass('active');
    });

    $(document).on( "click", '.bg-minicart-close', function(e){
        $('body').removeClass('open-minicart');
        $('.mini-cart-items').removeClass('active');
    });

    // Quantity Product
    $(document).on('click', '.product-form-qty-submit .product-form-item .product-minus', function() {
        var $inputQty = $(this).closest('.product-form-item').find('.product-form__input--quantity').first();
        var qty = parseInt($inputQty.val());
        if(qty > 1){
            qty = qty - 1;
            $inputQty.val(qty);
            if(qty == 1){
                $(this).addClass('disabled');
            }
        }
    });

    $(document).on('click', '.product-form-qty-submit .product-form-item .product-plus', function() {
        var $inputQty = $(this).closest('.product-form-item').find('.product-form__input--quantity').first();
        var qty = parseInt($inputQty.val());
        qty = qty + 1;
        $inputQty.val(qty);
        $('.product-form-qty-submit .product-form-item .product-minus').removeClass('disabled');
        if(qty != 1){
            $(this).closest('.product-form-item').find('product-minus').first().removeClass('disabled');
        }
    });

    // Quantity Item Minicart
    $(document).on('click', '.mincart__product-qty .product-form-qty .product-minus', function() {
        var item_id = $(this).closest('.product-form-item').data('id');
        var $inputQty = $(this).closest('.product-form-item').find('.product-form__input--quantity').first();
        $(this).prop('disabled', true);
        var qty = parseInt($inputQty.val());
        if(qty > 1){
            qty = qty - 1;
            $inputQty.val(qty);
            if(qty == 1){
                $(this).addClass('disabled');
            }
        }

        if (window.giftWrapId !== item_id ) {
            updateMinicartQty(item_id, qty);
        }
    });

    $(document).on('click', '.mincart__product-qty .product-form-qty .product-plus', function() {
        var item_id = $(this).closest('.product-form-item').data('id');
        var $inputQty = $(this).closest('.product-form-item').find('.product-form__input--quantity').first();
        $(this).prop('disabled', true);
        var qty = parseInt($inputQty.val());
        qty = qty + 1;
        $inputQty.val(qty);
        $(this).closest('.product-form-item').find(' .product-minus').removeClass('disabled');
        if(qty != 1){
            $(this).closest('.product-form-item').find('product-minus').first().removeClass('disabled');
        }

        if (window.giftWrapId !== item_id ) {
            updateMinicartQty(item_id, qty);
        }
    });

    // Remove Minicart
    $(document).on('click', '.cart-details .delete', function() {
        const id = $(this).data('cart-item');
        const giftWrapId = window.giftWrapId;

        if (id === Number(giftWrapId)) {
            removeAllItemWrapProperties()
              .then(() => {
                  return $.ajax({
                      method: "POST",
                      url: "/cart/update.js",
                      data: `updates[${id}]=0`,
                      dataType: "json"
                  });
              })
              .then(() => {
                  refreshMiniCart();
              })
              .catch(error => console.error('Error handling Gift Wrap removal:', error));
        } else {
            $('.mini-cart-content #mincart-loading').show();
            $.ajax({
                method: "POST",
                url: "/cart/update.js",
                data: `updates[${id}]=0`,
                dataType: "json",
                success: function(response) {
                    if (response['item_count'] === 0) {
                        $('#close-cart').trigger('click');
                    }
                    refreshMiniCart();
                    // Recalculate GW quantity after any non-GW item is removed
                    if (window.giftWrapId) {
                        recalculateGiftWrapQuantity();
                    }
                },
                error: function(XMLHttpRequest, textStatus) {
                    $('.mini-cart-content #mincart-loading').hide();
                    handleError(XMLHttpRequest);
                }
            });
        }
    });

    $(document).on('click', '#store-details a', function(){
        var name = $(this).attr('data-store');
        if(name){
            window.location.href = '/pages/'+name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
        }
    });

    /* MINICART FUNCTIONS */
    //reinit minicart
    function refreshMiniCart(lineitem, quantity) {
        if ($('body').hasClass('template-cart')) {
            window.location.reload();
        } else {
            $.ajax({
                method: "GET",
                url: "/cart",
                data: {"view": "ajax"},
                xhrFields: {
                    withCredentials: true
                },
                dataType: 'html',
                success: function(response) {
                    //console.log(response);
                    var CartCount = $(response).find('.cartCount').html();
                    var contentCartHtml = $(response).find('.mini-cart-wrapper').first().html();
                    //console.log(contentCartHtml);
                    if(CartCount){
                        $('.cartCount').text(CartCount);
                    }
                    if (contentCartHtml) {
                        $('.mini-cart-wrapper').html(contentCartHtml);
                    }
                },
                error: function(XMLHttpRequest, textStatus) {
                    handleError(XMLHttpRequest);
                }
            });
        }
    }

    function updateMinicart(product_id, product_quantity) {
        var id = product_id;
        var qty = product_quantity;

        $.ajax({
            method: "POST",
            url: "/cart/update.js",
            data: "updates["+ id +"]=" + qty,
            dataType: "json",
            success: function(response) {
                $('.mini-cart-content #mincart-loading').show();
                $.ajax({
                    method: "GET",
                    url: "/cart",
                    data: {"view": "ajax"},
                    xhrFields: {
                        withCredentials: true
                    },
                    dataType: 'html',
                    success: function(response) {
                        var CartCount = $(response).find('.cartCount').html();
                        var contentCartHtml = $(response).find('.mini-cart-wrapper').first().html();
                        if(CartCount){
                            $('.cartCount').text(CartCount);
                        }
                        if (contentCartHtml) {
                            $('.mini-cart-wrapper').html(contentCartHtml);
                        }
                    },
                    error: function(XMLHttpRequest, textStatus) {
                        handleError(XMLHttpRequest);
                    }
                });
            },
            error: function(XMLHttpRequest, textStatus) {
                $('.mini-cart-content #mincart-loading').hide();
                handleError(XMLHttpRequest);
            }
        });
    }

    function updateMinicartQty(product_id, product_quantity) {
        var id = product_id;
        var qty = product_quantity;

        $.ajax({
            method: "POST",
            url: "/cart/update.js",
            data: "updates["+ id +"]=" + qty,
            dataType: "json",
            success: function(response) {
                $('.mini-cart-content #mincart-loading').show();
                $.ajax({
                    method: "GET",
                    url: "/cart",
                    data: {"view": "ajax"},
                    xhrFields: {
                        withCredentials: true
                    },
                    dataType: 'html',
                    success: function(response) {
                        var CartCount = $(response).find('.cartCount').html();
                        var contentCartHtml = $(response).find('.mini-cart-wrapper').first().html();
                        if(CartCount){
                            $('.cartCount').text(CartCount);
                        }
                        if (contentCartHtml) {
                            $('.mini-cart-wrapper').html(contentCartHtml);
                        }

                        if (window.giftWrapId) {
                            recalculateGiftWrapQuantity();
                        }
                    },
                    error: function(XMLHttpRequest, textStatus) {
                        handleError(XMLHttpRequest);
                    }
                });
            },
            error: function(XMLHttpRequest, textStatus) {
                $('.mini-cart-content #mincart-loading').hide();
                handleError(XMLHttpRequest);
            }
        });
    }

    /**
     /* Gift cart feature
     */

    if (document.body.classList.contains('template-cart')) {
        return;
    }

    async function recalculateGiftWrapQuantity() {
        try {
            const response = await fetch('/cart.js');
            if (!response.ok) throw new Error('Failed to fetch cart data');

            const cart = await response.json();
            const totalGWQuantity = cart.items.reduce((acc, item) => {
                return acc + (item.properties?.['Should be wrapped'] === 'Yes' ? item.quantity : 0);
            }, 0);

            if (totalGWQuantity > 0) {
                updateMinicart(window.giftWrapId, totalGWQuantity);
            } else {
                updateMinicart(window.giftWrapId, 0);
            }
        } catch (error) {
            console.error("Error recalculating GW quantity:", error);
        }
    }

    function removeAllItemWrapProperties() {
        const mainCheckbox = document.querySelector('.js-gift-wrap-checkbox');
        if (mainCheckbox) {
            mainCheckbox.checked = false;
            mainCheckbox.dispatchEvent(new Event('change'));
        } else {
            console.warn("Main checkbox not found.");
        }
    }

    class GiftWrap extends HTMLElement {
        constructor() {
            super();
            this.textAreaWrapper = this.querySelector('.js-gift-message');
            this.textArea = this.querySelector('.js-gift-textarea');
            this.mainCheckbox = this.querySelector('.js-gift-wrap-checkbox');
            this.itemCheckboxes = Array.from(document.querySelectorAll('.js-wrap-item-checkbox-minicart'));
            this.giftWrapId = this.dataset.giftwrapId;
            this.debouncedOnGiftWrapMessageChange = debounce(this.onGiftWrapMessageChange.bind(this), 300);
            this.cartItems = document.querySelector('.mini-cart-wrapper');

            if (this.mainCheckbox) {
                this.attachListeners();
                this.initializeCheckboxState();
            }
        }

        sanitizeMessage(message) {
            if (!message) return '';
            const harmfulTagsPattern = /<(script|style|iframe|object|embed)[^>]*>[\s\S]*?<\/\1>/gi;
            message = message.replace(harmfulTagsPattern, '');
            message = message.replace(/<[^>]+>/g, '');
            if (message.length > 198) {
                message = message.substring(0, 198);
            }
            
            return message;
        }

        noteFormatter(note) {
            if (!note) return '';
            let formattedNote = note.replace(/([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g, '');
            return this.sanitizeMessage(formattedNote);
        }

        checkMainCheckboxState() {
            const allChecked = this.itemCheckboxes.every(checkbox =>
              checkbox.dataset.itemId === String(this.giftWrapId) || checkbox.checked
            );
            const anyChecked = this.itemCheckboxes.some(checkbox =>
              checkbox.dataset.itemId !== String(this.giftWrapId) && checkbox.checked
            );

            //console.log('Main checkbox state check:', { allChecked, anyChecked });
            this.mainCheckbox.checked = allChecked;
            this.mainCheckbox.indeterminate = !allChecked && anyChecked;
        }


        async onMainCheckboxChange() {
            const shouldBeWrapped = this.mainCheckbox.checked;
            //console.log(`Main checkbox changed: ${shouldBeWrapped ? 'Checked' : 'Unchecked'}`);
            await this.toggleIndividualItemsWrap(shouldBeWrapped);
            await this.updateGiftWrapQuantity();
            this.checkMainCheckboxState();
        }

        async onIndividualCheckboxChange(event) {
            const checkbox = event.target;
            const itemKey = checkbox.dataset.itemKey;
            const shouldBeWrapped = checkbox.checked;
            
            // console.log('GiftWrap Debug:', {
            //     itemKey,
            //     shouldBeWrapped,
            //     checkboxDataset: checkbox.dataset,
            //     element: this
            // });

            try {
                const cartResponse = await fetch('/cart.js');
                if (!cartResponse.ok) {
                    throw new Error(`Failed to fetch cart: ${cartResponse.status}`);
                }
                const cart = await cartResponse.json();
                const cartItem = cart.items.find(item => item.key === itemKey);
                if (!cartItem) {
                    throw new Error(`Item ${itemKey} not found in cart`);
                }

                let properties = {};
                if (cartItem.properties) {
                    properties = { ...cartItem.properties };
                }
                properties['Should be wrapped'] = shouldBeWrapped ? 'Yes' : '';

                // console.log('Updating item properties:', {
                //     itemKey,
                //     properties,
                //     currentCartItem: cartItem
                // });

                const updateResponse = await fetch('/cart/change.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        id: itemKey,
                        quantity: cartItem.quantity, // Use actual quantity from cart
                        properties: properties
                    })
                });

                if (!updateResponse.ok) {
                    throw new Error(`Failed to update cart: ${updateResponse.status}`);
                }

                const updateResult = await updateResponse.json();
                //console.log('Cart update result:', updateResult);

                await this.updateGiftWrapQuantity();
                this.checkMainCheckboxState();
            } catch (error) {
                console.error('GiftWrap Error:', {
                    message: error.message,
                    itemKey,
                    shouldBeWrapped,
                    stack: error.stack
                });
                
                checkbox.checked = !shouldBeWrapped;
                const errorMessage = `Failed to update gift wrap status: ${error.message}`;
                console.error(errorMessage);
            }
        }

        async updateGiftWrapQuantity() {
            try {
                const response = await fetch('/cart.js');
                if (!response.ok) throw new Error('Failed to fetch cart data');
                const cart = await response.json();
                const totalGWQuantity = cart.items.reduce((acc, item) => {
                    if (item.variant_id !== Number(this.giftWrapId) && item.properties?.['Should be wrapped'] === 'Yes') {
                        //console.log(`Item marked for wrap - ID: ${item.id}, Title: ${item.title}, Quantity: ${item.quantity}`);
                        return acc + item.quantity;
                    }
                    return acc;
                }, 0);

                //console.log("Calculated total required GW quantity based on wrapped items:", totalGWQuantity);
                if (totalGWQuantity > 0) {
                    updateMinicart(this.giftWrapId, totalGWQuantity);
                    this.textAreaWrapper.classList.remove('hidden');
                } else {
                    updateMinicart(this.giftWrapId, 0);
                    this.textAreaWrapper.classList.add('hidden');
                }
            } catch (error) {
                console.error("Error updating GW quantity:", error);
            }
        }

        async onGiftWrapMessageChange() {
            if (!this.textArea) return;

            this.textArea.value = this.noteFormatter(this.textArea.value);
            const cartGiftWrapItem = this.cartItems.querySelector('.js-cart-item-gift-wrap');
            await this.updateGiftWrapMessage(cartGiftWrapItem, this.textArea.value);
        }

        async updateGiftWrapMessage(giftWrapItem = this.cartItems.querySelector('.js-cart-item-gift-wrap'), giftWrapMessage = "") {
            if (!giftWrapItem) return;
            const index = giftWrapItem.dataset.giftWrapIndex;
            const body = JSON.stringify({ line: index, properties: { "Gift Message": giftWrapMessage } });

            return await fetch(`${window.location.origin}/cart/change.js`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body
            });
        }

        async toggleIndividualItemsWrap(shouldWrap) {
            //console.log(`Applying wrap status to all items: ${shouldWrap ? 'Yes' : 'No'}`);
            try {
                const response = await fetch('/cart.js');
                if (!response.ok) throw new Error('Failed to fetch cart data');
                const cart = await response.json();
                for (const item of cart.items) {
                    if (item.variant_id !== Number(this.giftWrapId) && !item.properties._dontwrap) {
                        //console.log(`Setting "Should be wrapped" for item ID ${item.key} to: ${shouldWrap ? 'Yes' : 'No'}`);

                        let properties = {}
                        if (item.properties) {
                            properties = item.properties
                        }
                        properties['Should be wrapped'] = shouldWrap ? 'Yes' : ''

                        await fetch(`${window.location.origin}/cart/change.js`, {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify({
                                id: item.key,
                                quantity: item.quantity,
                                properties: properties
                            })
                        });

                        const checkbox = this.itemCheckboxes.find(cb => cb.dataset.itemKey === item.key);
                        if (checkbox) checkbox.checked = shouldWrap;
                    }
                }

                refreshMiniCart();

            } catch (error) {
                console.error('Error toggling wrap status for individual items:', error);
            }
        }

        attachListeners() {
            if (this.mainCheckbox) {
                this.mainCheckbox.addEventListener('change', this.onMainCheckboxChange.bind(this));
            }
            this.itemCheckboxes.forEach(checkbox => {
                checkbox.addEventListener('change', this.onIndividualCheckboxChange.bind(this));
            });
            if (this.textArea) {
                this.textArea.addEventListener('input', this.debouncedOnGiftWrapMessageChange);
            }
        }

        initializeCheckboxState() {
            const cartGiftWrapItem = this.cartItems.querySelector('.js-cart-item-gift-wrap');
            this.mainCheckbox.checked = !!cartGiftWrapItem;
            this.textAreaWrapper.classList.toggle('hidden', !cartGiftWrapItem);
            const allChecked = this.itemCheckboxes.every(checkbox =>
              checkbox.dataset.itemId === String(this.giftWrapId) || checkbox.checked
            );
            const anyChecked = this.itemCheckboxes.some(checkbox =>
              checkbox.dataset.itemId !== String(this.giftWrapId) && checkbox.checked
            );
            this.mainCheckbox.checked = allChecked;
            this.mainCheckbox.indeterminate = !allChecked && anyChecked;
        }

        async debugCartState() {
            try {
                const response = await fetch('/cart.js');
                const cart = await response.json();
                // console.log('Current Cart State:', {
                //     items: cart.items,
                //     giftWrapId: this.giftWrapId,
                //     totalItems: cart.item_count,
                //     totalPrice: cart.total_price
                // });
                return cart;
            } catch (error) {
                console.error('Failed to fetch cart state:', error);
                throw error;
            }
        }
    }

    customElements.define('gift-wrap', GiftWrap);

    function debounce(fn, wait) {
        let t;
        return (...args) => {
            clearTimeout(t);
            t = setTimeout(() => fn.apply(this, args), wait);
        };
    }

});

jQuery(document).ready(function($){
    $('.search-form__input').on('focus', function(){
        checkPositionInputSearch();
    });
    $('.search-form__input').keypress(function(){
        checkPositionInputSearch();
    });
    function checkPositionInputSearch(){
        var currentTop = $(window).scrollTop();
        if(currentTop > 0){
            $('.algolia-autocomplete').removeClass('focus-at-top');
        }else if(currentTop == 0){
            $('.algolia-autocomplete').addClass('focus-at-top').addClass('on-top');
        }else {
            $('.algolia-autocomplete').addClass('focus-at-top');
        }
    };
});

// Scroll header Sticky
jQuery(document).ready(function($){
    $('[data-section-id="header"]').addClass('active');
    $('#cov-mobile-navigation').addClass('scroll');
    $(window).scroll(function (event) {
        var st = $(this).scrollTop();
        if(st == 0){
            $('[data-section-id="header"]').addClass('active');
            $('#cov-mobile-navigation').addClass('scroll');
        }else{
            $('[data-section-id="header"]').removeClass('active');
            $('#cov-mobile-navigation').removeClass('scroll');
        }
    });
    var mainHeader = $('[data-section-id="header"]'),
      secondaryNavigation = $('.announcement-bar'),
      //this applies only if secondary nav is below intro section
      belowNavHeroContent = $('.sub-nav-hero'),
      headerHeight = mainHeader.height();

    //set scrolling variables
    var scrolling = false,
      previousTop = 0,
      currentTop = 0,
      scrollDelta = 10,
      scrollOffset = 150;

    mainHeader.on('click', '.nav-trigger', function(event){
        // open primary navigation on mobile
        event.preventDefault();
        mainHeader.toggleClass('nav-open');
    });

    $(window).on('scroll', function(){
        var currentTop = $(window).scrollTop();
        var searchContainer = $('.algolia-autocomplete');
        if(currentTop < 40){
            searchContainer.addClass('on-top');
        }else{
            searchContainer.removeClass('on-top');
        }

        if( !scrolling ) {
            scrolling = true;
            (!window.requestAnimationFrame)
              ? setTimeout(autoHideHeader, 250)
              : requestAnimationFrame(autoHideHeader);
        }
    });


    $(window).on('resize', function(){
        headerHeight = mainHeader.height();
    });

    function autoHideHeader() {
        var currentTop = $(window).scrollTop();

        ( belowNavHeroContent.length > 0 )
          ? checkStickyNavigation(currentTop) // secondary navigation below intro
          : checkSimpleNavigation(currentTop);

        previousTop = currentTop;
        scrolling = false;
    }

    function checkSimpleNavigation(currentTop) {
        //there's no secondary nav or secondary nav is below primary nav
        if (previousTop - currentTop > scrollDelta) {
            //if scrolling up...
            mainHeader.removeClass('is-hidden');
            $('.algolia-autocomplete').removeClass('disable');
        } else if( currentTop - previousTop > scrollDelta && currentTop > scrollOffset) {
            //if scrolling down...
            mainHeader.addClass('is-hidden');
            $('.algolia-autocomplete').addClass('disable');
        }
    }

    function checkStickyNavigation(currentTop) {
        //secondary nav below intro section - sticky secondary nav
        var secondaryNavOffsetTop = belowNavHeroContent.offset().top - secondaryNavigation.height() - mainHeader.height();

        if (previousTop >= currentTop ) {
            //if scrolling up...
            if( currentTop < secondaryNavOffsetTop ) {
                //secondary nav is not fixed
                mainHeader.removeClass('is-hidden');
                secondaryNavigation.removeClass('fixed slide-up');
                belowNavHeroContent.removeClass('secondary-nav-fixed');
            } else if( previousTop - currentTop > scrollDelta ) {
                //secondary nav is fixed
                mainHeader.removeClass('is-hidden');
                secondaryNavigation.removeClass('slide-up').addClass('fixed');
                belowNavHeroContent.addClass('secondary-nav-fixed');
            }

        } else {
            //if scrolling down...
            if( currentTop > secondaryNavOffsetTop + scrollOffset ) {
                //hide primary nav
                mainHeader.addClass('is-hidden');
                secondaryNavigation.addClass('fixed slide-up');
                belowNavHeroContent.addClass('secondary-nav-fixed');
            } else if( currentTop > secondaryNavOffsetTop ) {
                //once the secondary nav is fixed, do not hide primary nav if you haven't scrolled more than scrollOffset
                mainHeader.removeClass('is-hidden');
                secondaryNavigation.addClass('fixed').removeClass('slide-up');
                belowNavHeroContent.addClass('secondary-nav-fixed');
            }

        }
    }
});
